import { MutationTree } from "vuex";
import { ArmDisarmState, GroupIsOnTestOverride, SiteTreeFilter, SiteTreeNodeWithOnTestEvents } from "./types";
import Vue from "vue";
import { Group, GroupStatus, SiteTreeNode } from "@/store/eventqueue/types";
import { getDefaultState } from "./state";
import { Region } from "@/store/types";

export const mutations: MutationTree<ArmDisarmState> = {
	setTreeGroupSelected(state: ArmDisarmState, group: Group) {
		state.selectedGroup = group;
	},

	setSelectedRegion(state: ArmDisarmState, region: Region) {
		state.selectedRegion = region;
	},

	setCurrentTab(state: ArmDisarmState, status: GroupStatus) {
		state.currentTab = status;
	},

	setArmDisarmShown(state: ArmDisarmState, visible: boolean) {
		state.armDisarmShown = visible;
	},

	setGroupIsArmedModalVisibility(state: ArmDisarmState, visible: boolean): void {
		state.groupIsArmedModalVisible = visible;
	},

	setGroupIsDisarmedModalVisibility(state: ArmDisarmState, visible: boolean): void {
		state.groupIsDisarmedModalVisible = visible;
	},

	setGroupIsOnTestModalVisibility(state: ArmDisarmState, visible: boolean): void {
		state.groupIsOnTestModalVisible = visible;
	},

	setGroupIsOnTestOverride(state: ArmDisarmState, groupIsOnTestOverride: GroupIsOnTestOverride) {
		state.groupIsOnTestOverride = groupIsOnTestOverride;
	},

	resetState(state: ArmDisarmState): void {
		Object.assign(state, getDefaultState());
	}
};
